import { useQueryClient } from '@tanstack/react-query';

import {
  ContratosActionsKeysEnum,
  EstadosContratoChoiceEnum,
  gridSizeMdLg12,
  useIsMediaQuery,
} from '@/shared';
import {
  SuspendCurrentServiceData,
  useUpdateContrato,
} from '@/shared/actions/erp';
import { Contrato, EstadosNavegacionEnum } from '@/shared/interfaces';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { Button, CircularProgress, Grid } from '@mui/material';

export type ClienteFibraBtnsServiceContractProps = {
  contract: Contrato;
};

const ClienteFibraBtnsServiceContract: React.FC<
  ClienteFibraBtnsServiceContractProps
> = ({ contract }) => {
  const isMobile = useIsMediaQuery('sm');
  const queryClient = useQueryClient();

  ///* global state -------------------------
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);

  const onInvalidateQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: [ContratosActionsKeysEnum.CONTRATO],
    });
  };

  ///* mutations -------------------------
  const {
    mutateAsync: updateContractServiceStatus,
    isPending: loadingContractServiceStatus
  } = useUpdateContrato<SuspendCurrentServiceData>({
    enableRedirect: false,
    customSuccessMessage: "Actualización realizada con éxito"
  });

  ///* handlers -------------------------
  const onSuspend = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Suspender Servicio',
      subtitle: '¿Está seguro de querer suspender el servicio actual?',
      onConfirm: async () => {
        setConfirmDialogIsOpen(false);
        setIsGlobalLoading(true);
        await updateContractServiceStatus({
          id: contract?.id_contrato!,
          data: {
            estado_contrato: EstadosContratoChoiceEnum.SUSPENDIDO,
            estado_navegacion: EstadosNavegacionEnum.SUSPENDIDO
          },
        });
        await onInvalidateQuery();
        setIsGlobalLoading(false);
      },
    });
  };
  const onActivate = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Activar Servicio',
      subtitle: '¿Está seguro de querer activar el servicio para este cliente?',
      onConfirm: async () => {
        setConfirmDialogIsOpen(false);
        setIsGlobalLoading(true);
        await updateContractServiceStatus({
          id: contract?.id_contrato!,
          data: {
            estado_contrato: EstadosContratoChoiceEnum.ACTIVO,
            estado_navegacion: !(contract?.estado_navegacion) 
              || contract?.estado_navegacion==EstadosNavegacionEnum.EN_ESPERA? 
              EstadosNavegacionEnum.ACTIVO
              :EstadosNavegacionEnum.REACTIVADO,
          },
        });
        await onInvalidateQuery();
        setIsGlobalLoading(false);
      },
    });
  };

  // const onDeactivate = () => {
  //   setConfirmDialog({
  //     isOpen: true,
  //     title: 'Desactivar Servicio',
  //     subtitle: '¿Está seguro de querer desactivar el servicio para este cliente?',
  //     onConfirm: async () => {
  //       setConfirmDialogIsOpen(false);
  //       setIsGlobalLoading(true);
  //       await activateContractService.mutateAsync({
  //         id: contract?.id_contrato!,
  //         data: {
  //           estado_contrato: EstadosContratoChoiceEnum.INACTIVO,
  //         },
  //       });
  //       await onInvalidateQuery();
  //       setIsGlobalLoading(false);
  //     },
  //   });
  // };

  return (
    <Grid item {...gridSizeMdLg12} sx={{marginTop:2}} >
      <Grid
        container
        spacing={isMobile ? 1 : 2}
        justifyContent="start"
        alignItems="center"
      >
        {
          loadingContractServiceStatus?
            <Grid item {...gridSizeMdLg12} justifyContent={"center"}>
              <CircularProgress color="inherit" />
            </Grid>
          :
          <>
            {
              contract.estado_contrato == EstadosContratoChoiceEnum.SUSPENDIDO
              && (
              <Grid item xs={isMobile ? 12 : 'auto'}>
                  <Button
                    variant="outlined"
                    color="success"
                    fullWidth={isMobile}
                    onClick={() => onActivate()}
                  >
                    ACTIVAR
                  </Button>
              </Grid>
            )}

            {
              contract.estado_contrato == EstadosContratoChoiceEnum.ACTIVO
              && (
                <Grid item xs={isMobile ? 12 : 'auto'}>
                    <Button
                      variant="outlined"
                      color="warning"
                      fullWidth={isMobile}
                      onClick={() => onSuspend()}
                    >
                      SUSPENDER
                    </Button>
                </Grid>
              )
            }

          </>
        }
        
        
        {/* <Grid item xs={isMobile ? 12 : 'auto'}>
            <Button
              variant="outlined"
              color="error"
              fullWidth={isMobile}
              onClick={() => onDeactivate()}
              disabled
              // disabled={contract.estado_contrato != EstadosContratoChoiceEnum.INACTIVO? 
              //   false : true}
            >
              Desactivar
            </Button>
        </Grid> */}

        {/* <Grid item xs={isMobile ? 12 : 'auto'}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth={isMobile}
            onClick={() => {
              alert('CAMBIAR PLAN');
            }}
          >
            CAMBIAR PLAN
          </Button>
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default ClienteFibraBtnsServiceContract;
